export const submenulist = [
    { 
        name : "CREATE NOTE" ,
        route : "createnote",
        Icon : "note_add",
    },
    { 
        name : "All NOTE" ,
        route : "home",
        Icon : "note",
    },
    { 
        name : "ADD TAG" ,
        route : "label",
        Icon : "label_outline",
    },
    { 
        name : "ARCHIVE" ,
        route : "archive",
        Icon : "archive",
    },
    { 
        name : "TRASH" ,
        route : "trash",
        Icon : "delete",
    },
    { 
        name : "PROFILE" ,
        route : "profile",
        Icon : "person",
    },
]